// extracted by mini-css-extract-plugin
module.exports = {"PersonSmall":"PersonSmall_PersonSmall__1YUkd"};